import React, { Component } from 'react'
import styled from '@emotion/styled'
import { SwitchInput } from 'stylist'
import debounce from 'lodash/debounce'
import serializeErrorMessages from 'utils/serializeErrorMessages'

const StyledSwitch = styled(SwitchInput)`
  height: 20px;
`

class SwitchWithMutation extends Component {
  state = {
    active: false
  }

  constructor(props) {
    super(props)
    this.state.active = props.initialValue
    this.save = debounce(this.performSave, 500)
  }

  toggle(e) {
    const value = e.target.checked
    this.setState({ active: value }, this.save)
  }

  performSave = value => {
    const { mutate, buildMutationOptions } = this.props

    mutate(buildMutationOptions(this.state.active)).catch(e =>
      Promise.reject(serializeErrorMessages(e))
    )
  }

  render() {
    return (
      <StyledSwitch
        id={this.props.id}
        checked={this.state.active}
        onChange={e => this.toggle(e)}
        {...this.props}
      />
    )
  }
}

export default SwitchWithMutation



// WEBPACK FOOTER //
// ./src/components/SwitchWithMutation.js